import React, { Component } from 'react';
import { connect } from 'react-redux';

import UserControlDisplay from './UserControlDisplay';
import { setup_user } from '../../../utils/apputils';

class UserControl_Class extends Component {
  componentDidMount() {
    const { dispatch } = this.props;
    setup_user(dispatch);
  }
  render() {
    return <UserControlDisplay />;
  }
}
const UserControl = connect()(UserControl_Class);
export default UserControl;



// WEBPACK FOOTER //
// ./src/comps/Navbar/components/UserControl.js